import React from 'react';
const cities = ['Phoenix', 'Gilbert', 'Chandler', 'Mesa', 'Tempe', 'Scottsdale', 'Ahwatukee', 'Paradise Valley', 'Queen Creek', 'San Tan Valley', 'Gold Canyon', 'Sun Lakes'];
export function ServiceAreasSection() {
  return <section id="areas" className="py-16 md:py-24 bg-light-gray" data-id="element-146">
      <div className="container mx-auto px-4 max-w-5xl text-center" data-id="element-147">
        <h2 className="font-heading text-3xl md:text-4xl font-bold italic text-navy mb-4" data-id="element-148">
          Proudly Serving the Entire East Valley
        </h2>
        <p className="text-lg text-silver mb-12" data-id="element-149">
          Professional carpet and tile cleaning across the Phoenix metro.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-12" data-id="element-150">
          {cities.map((city, index) => <div key={index} className="bg-navy text-white rounded-full px-6 py-3 font-medium text-sm md:text-base shadow-sm hover:bg-red transition-colors cursor-default" data-id="element-151">
              {city}
            </div>)}
        </div>

        <p className="text-navy font-medium text-lg" data-id="element-152">
          Don't see your city? Give us a call — we likely serve your area too.
        </p>
      </div>
    </section>;
}